var exports = {
  "uW": "SettingsSection.module__section___UUM0MV",
  "bV": "SettingsSection.module__sectionHeader___UUM0MV",
  "sq": "SettingsSection.module__sectionTitleRow___UUM0MV",
  "vO": "SettingsSection.module__sectionActions___UUM0MV",
  "N1": "SettingsSection.module__subsectionActions___UUM0MV",
  "Gf": "SettingsSection.module__sectionTitle___UUM0MV",
  "yV": "SettingsSection.module__sectionDescription___UUM0MV",
  "f5": "SettingsSection.module__sectionContent___UUM0MV",
  "t8": "SettingsSection.module__subsectionHeader___UUM0MV",
  "Wf": "SettingsSection.module__subsectionTitle___UUM0MV",
  "Yq": "SettingsSection.module__subsectionDescription___UUM0MV",
  "No": "SettingsSection.module__subsectionContent___UUM0MV",
};

module.exports = exports;
